import { QueryClient } from '@tanstack/react-query';
import { isClientError } from '@/lib/api-errors';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            // React Query retries three times with backoff by default, so an
            // expired session used to sit on a spinner for ~7s before any
            // screen even reached its error state. A 4xx is never going to
            // turn into a 2xx on the next try.
            retry: (failureCount, error) => failureCount < 3 && !isClientError(error),
        },
    },
});

export default queryClient;
